import { render, staticRenderFns } from "./RegistroInstitucion.vue?vue&type=template&id=327b7a5f&scoped=true"
import script from "./RegistroInstitucion.vue?vue&type=script&lang=js"
export * from "./RegistroInstitucion.vue?vue&type=script&lang=js"
import style0 from "./RegistroInstitucion.vue?vue&type=style&index=0&id=327b7a5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327b7a5f",
  null
  
)

export default component.exports